import apiClient from './config';

export const login = (credentials) => apiClient.post('/auth/login', credentials);
export const getProfile = () => apiClient.get('/auth/perfil');
export const register = (userData) => apiClient.post('/auth/registro', userData);